import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';
import { Breakpoints } from 'styles/variables/breakpoints';

const { white } = Colors;
const { lg } = Breakpoints;

export const Certificate = styled.div`
    width: 50%;
    img {
        max-width: 100%;
        max-height: 100%;
    }
    @media screen and (max-width: 767px) {
        width: 80%;
    }

    @media screen and (max-width: 510px) {
        width: 65%;
    }
`;

export const Certificates = styled.div`
    display: flex;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 2rem;

    @media screen and (max-width: 767px) {
        padding-bottom: 1rem;
        flex-direction: column;
    }
`;

export const Container = styled.div`
    background-color: ${white};
    width: 80%;
    display: block;
    align-self: center;
    margin: auto;
    margin-bottom: 2rem;
    @media screen and (max-width: 575px) {
        margin-bottom: 1.5rem;
    }
`;

export const Title = styled.p`
    ${TextStyle({ fontSize: '20px', fontWeight: '600' })}
    text-align: center;
    margin-top: 3.5rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    line-height: 130%;
    text-transform: capitalize;

    @media screen and (max-width: ${lg}) {
        font-size: 16px;
        margin-top: 2.5rem;
    }

    @media screen and (max-width: 767px) {
        margin-top: 2rem;
    }

    @media screen and (max-width: 575px) {
        margin-top: 1.5rem;
    }
    @media screen and (max-width: 510px) {
        display: none;
    }
`;

export const TitleMobile = styled.p`
    ${TextStyle({ fontSize: '14px', fontWeight: '700' })}
    text-align: center;
    margin-top: 1.5rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    line-height: 130%;
    padding-top: 1rem;
    text-transform: capitalize;
    @media screen and (min-width: 510px) {
        display: none;
    }
`;
